module.exports = __webpack_public_path__ + "img/exam_jan_2025_37t32l2v.231493a8.jpg";